export const GET_TECH_DATA = 'sci/GET_TECH_DATA'